$(document).ready(function(){
  var announce_height = $('.announce_sec').innerHeight();
  var head_height = $('.section-header').innerHeight();
  var screen_height = $(window).height() - announce_height - head_height;

  //Full Height 
  $('.fill_height').css('height', screen_height+'px');

  // FAQ's Active Classes
  $('.faq_list').on('click','.faq_list_head', function(e){
    e.preventDefault();
    if($(this).parent('.faq_list').hasClass('faq_list_active')){
      $(this).parent('.faq_list').removeClass('faq_list_active');
      $(this).siblings('.faq_answer').slideToggle('medium','linear');
    } else {
      $(this).parent('.faq_list').addClass('faq_list_active');
      $(this).siblings('.faq_answer').slideToggle('medium','linear');
      $(this).parent('.faq_list').siblings('.faq_list_active').find('.faq_answer').slideToggle('medium','linear');
      $(this).parent('.faq_list').siblings('.faq_list_active').removeClass('faq_list_active');
    }
  });
});



/* You can add your custom scripts here */
// $.fn.circulateText = function(radius,space=10) {
 
//     return this.each(function() {
	
// 		var text= $(this).text().trim();
// 	    	var textLengh = text.length;
// 		$(this).empty();
		
// 		$(this).append('<div class="innerWrapper" style="position:relative"></div>');
// 		var innerWrapper = $(this).find('.innerWrapper');
		
// 		var stepAngle = space;
// 		var startAngle= -(space * textLengh/2)+(space/2);
		
// 		for(i=0; i<textLengh; i++)
// 		{
// 		    $(innerWrapper).append('<span class="singleChar" style="height:'+radius+'px; position:absolute; left:'+$(innerWrapper).width()/2+'px;">'+text[i]+'</span>');
// 		    $(innerWrapper).find('.singleChar').last().rotate({
// 				angle:startAngle,
// 				center: ["50%", "100%"]
// 			});
// 			startAngle = startAngle + stepAngle;
// 		}
		
//     });
 
// };
// $(document).ready(function(){
//     $(".cicon_circle_up").circulateText(200);
// });